import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {
    IVoceCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetVociCosto = (): UseQueryResult<IVoceCosto[], CustomAxiosError> => {

    const {get} = useApiCalls()
    const {selectedCompany} = useAuth()

    async function doGet(): Promise<IVoceCosto[]> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/voci_costo`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ['useApiGetVociCosto'],
        queryFn: () => doGet(),
    })
};

export default useApiGetVociCosto